<template>
    <div class="newsletter-box">
        <form novalidate @submit.prevent="validateEmailForm">
            <div class="row no-gutters">
                <div class="col">
                    <input
                        v-model="email"
                        v-validate="'email|required'"
                        :class="{ 'required': errors.has('email') }"
                        data-vv-validate-on="change"
                        name="email"
                        type="email"
                        class="form-control"
                        placeholder="jondoe@mail.com"
                    >
                </div>
                <div class="col-auto">
                    <button class="btn" :class="{ 'required': errors.has('email') }">
                        Get it Now!
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: "NewsletterBox",
    data() {
        return {
            mailchimp_list_id: process.env.VUE_APP_MAILCHIMP_LIST_ID,
            email: ""
        };
    },
    methods: {
        async validateEmailForm() {
            const isFormValid = await this.$validator.validate();
            if (isFormValid) {
                this.subscribeToNewsLetter();
            }
        },
        subscribeToNewsLetter() {
            this.sendTrackings();
            axiosMemod({
                url: `/newsletter`,
                method: "POST",
                data: {
                    email: this.email,
                    list_id: this.mailchimp_list_id
                }
            }).then(() => {
                this.email = "";
                this.$notify({
                    group: "app-notifications",
                    type: "success",
                    text: "You've been subscribed!.",
                    duration: 5000
                });
            }).catch(() => {
                this.$notify({
                    group: "app-notifications",
                    type: "error",
                    text: "Something went wrong!.",
                    duration: 5000
                });
            })
        },
        sendTrackings() {
            this.$_trackAll("bi-conv-landing-fnsu-atf", {
                action: "fnsu-atf"
            });
            this.$_gtmTrackEvent({
                event: "bi-conv-landing-fnsu-atf",
                action: "fnsu-atf"
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.newsletter-box {
    .form-control {
        border-radius: 50px;
        height: 53px;
        background-color: #232121;
        border: 0;
        color: white;
        padding-left: 30px;


        &::placeholder {
            color: #A29E9E;
            font-weight: 300;
            font-size: 14   px;
        }

        &.required {
            border: 1px solid $error-color;
        }
    }

    .btn {
        background-color: #52504E;
        color: $primary-color;
        height: 100%;
        font-size: 18px;
        padding: .7rem 2rem;
        margin-left: -50px;

        &.required {
            border: 1px solid $error-color;
        }
    }
}
</style>
